import script from "./AbstractSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbstractSummary.vue?vue&type=script&setup=true&lang=ts"

import "./AbstractSummary.vue?vue&type=style&index=0&id=2343198e&lang=scss"

const __exports__ = script;

export default __exports__